import { Builder } from '@builder.io/sdk';
import { FeaturedArticles } from './FeaturedArticles';
import {
  FEATURED_ARTICLES_DEFAULT_LIMIT,
  FEATURED_ARTICLES_NAME,
  FeaturedArticlesLayoutType,
} from './FeaturedArticles.types';

const FeaturesArticlesConfig = {
  name: FEATURED_ARTICLES_NAME,
  friendlyName: 'Featured Articles',
  description: 'A component to display featured articles in a carousel or grid layout.',
  inputs: [
    {
      name: 'layout',
      type: 'string',
      defaultValue: 'standard',
      enum: Object.values(FeaturedArticlesLayoutType),
    },
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Read the latest news on Front Cover',
    },
    {
      name: 'autoSelectLatest',
      type: 'boolean',
      friendlyName: 'Auto-select latest articles',
      helperText: 'When enabled, automatically shows the most recent articles. Disable to manually pick articles.',
      defaultValue: true,
    },
    {
      name: 'limit',
      type: 'number',
      friendlyName: 'Number of articles',
      helperText: `Maximum number of articles to display. Default: ${FEATURED_ARTICLES_DEFAULT_LIMIT}`,
      defaultValue: FEATURED_ARTICLES_DEFAULT_LIMIT,
      min: 1,
      max: 20,
      showIf: 'options.get("autoSelectLatest") !== false',
    },
    {
      name: 'articles',
      type: 'list',
      friendlyName: 'Articles',
      helperText: 'Manually select which articles to display.',
      showIf: 'options.get("autoSelectLatest") === false',
      subFields: [
        {
          name: 'article',
          type: 'reference',
          model: 'article',
        },
      ],
    },
    {
      name: 'tagVariant',
      type: 'string',
      friendlyName: 'Tag Color',
      helperText: 'Color variant for category tags. Use "dark" for purple tags on Guides pages.',
      defaultValue: 'primary',
      enum: ['primary', 'secondary'],
    },
  ],
};

Builder.registerComponent(FeaturedArticles, FeaturesArticlesConfig);
